import { h } from 'preact'
export const ArrowRight = () => {
    return (
      <svg class="icon icon-recs-arrow-right" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 1538231536">
          <circle id="Ellipse 9817" cx="28" cy="28" r="27.5" transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 56.5437)" stroke="black"/>
          <path id="Rectangle 280857" d="M24 16.5437L34.4754 27.0191C35.3174 27.8611 35.3174 29.2263 34.4754 30.0683L24 40.5437" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </svg>
    )
}